//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
const StageTeam = require('@/tbs/model/vo/StageTeam')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_GameMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_GameMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_GameMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    handleCreationComplete: function() {
        // console.log('handleCreationComplete')
        // this.target().match = this._bridge.getRouteQuery()
        // this.fetchStageTeam(this._bridge.getRouteQuery('matchGroupId'), this._bridge.getRouteQuery('stageId'))
        this.loadMatchRoundSeq()
    },
    handleCustomizedEvent: function(event) {
        if (event.type == 'load') {
            this.loadStageGroupTeam(event.data.matchGroupId, event.data.stageId, event.data.isGroupRound)
        }
        else {
            return true
        }
    },
    loadMatchRoundSeq: function() {
        const self = this
        const matchGroupId = self._bridge.getRouteQuery('matchGroupId')
        const roundSeq = self._bridge.getRouteQuery('roundSeq')
        self.loadViewObjectData(new StageTeam, {matchGroupId: matchGroupId}, function(viewData) {
            console.log('viewData', viewData)
            self.target().match = {
                matchGroupId: matchGroupId,
                roundSeq: roundSeq,
                roundList: viewData
            }
            const firstRoundItem = viewData[Number(roundSeq) - 1]
            self.loadStageGroupTeam(matchGroupId, firstRoundItem.stageId, firstRoundItem.isGroupRound)
        }, 'getRoundList')
    },
    loadStageGroupTeam: function(matchGroupId, stageId, isGroupRound) {
        if (isGroupRound) {
            this.loadGroupList(matchGroupId, stageId)
        }
        this.loadStageTeam(matchGroupId, stageId)
    },
    loadGroupList: function(matchGroupId, stageId) {
        const self = this
        self.loadViewObjectData(new StageTeam, {matchGroupId: matchGroupId, stageId: stageId}, function(viewData) {
            console.log('viewData', viewData)
            self.target().groupList = viewData
        }, 'getGroupList')
    },
    loadStageTeam: function(matchGroupId, stageId) {
        const self = this
        self.loadViewObjectData(new StageTeam, {matchGroupId: matchGroupId, stageId: stageId}, function(viewData) {
            console.log('viewData', viewData)
            self.target().teamList = viewData
        }, 'query')
    },
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_GameMediator, BaseMediator);

module.exports = tbs_controller_GameMediator